import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  addEntryButton: {
    marginLeft: -6
  }
});
